import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import history from "../../auth/history";
import AddedBeneficiaryDetails from "./AddedBeneficiaryDetails";
import { store } from "../../redux/store";
import ContentLoader from 'react-content-loader';
import { Link } from "react-router-dom";
import { setBankDetails, setBranchAddress, setIfscCode, setSelectedBankName, setSelectedBankId } from './../../redux/misc-data/misc-data.action';
const httpClient = axios.create();

class AddedBeneficiary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			password: '',
			otpRef: '',
			message: '',
			errorMessage: ''
		}
	}


	componentDidMount() {
	}
	componentWillUnmount() {
	}





	pagination = (event) => {
		event.preventDefault();


	}

	errorMessageCall = (error) => {
		this.setState({
			errorMessage: error
		})
	}

	addBeneficiary = () => {
		this.setState({
			errorMessage: ''
		})


		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}



		var bankDetailsUrl = '/api/v1/catalog/bank/all/summary';
		httpClient.get(bankDetailsUrl, { headers }
		).then((response) => {
			console.log('all bank details' + JSON.stringify(response.data));
			if (response.data.length > 0) {
				this.setState({
					bankDetails: response.data
				})
				store.dispatch(setBankDetails(response.data));
				store.dispatch(setSelectedBankName(''));
				store.dispatch(setIfscCode(''));
				store.dispatch(setBranchAddress(''));
				store.dispatch(setSelectedBankId(''));

				var goToaddbeneficiary = document.getElementById('goToaddbeneficiary');
				goToaddbeneficiary.click();

			} else {
				this.errorMessageCall('No Bank Found');
			}
		}
		).catch(error => {
			this.errorMessageCall('Something went wrong,please try again later!');
			
		});

	}


	render() {

		return (
			<div>
				<div class="subhead">
					<h3>Added Beneficiary</h3>
					<button class="lbbtn" onClick={this.addBeneficiary} type="button">Add Beneficiary</button>
				</div>
				{this.state.errorMessage != '' &&
					<div class='valid-error'>
						{this.state.errorMessage}
					</div>
				}

				<Link to='/add-beneficiary'>
					<button id='goToaddbeneficiary' hidden={true}>
					</button>
				</Link>

				<div class="benefcr-list">
					{
						this.props.selecetdBenefisciaries.length > 0 ?

							this.props.selecetdBenefisciaries.map(
								benefisciary => (
									<AddedBeneficiaryDetails
										beneMobile={benefisciary.mobile}
										beneId={benefisciary.id}
										verifiedAccount={benefisciary.verified}
										name={benefisciary.name} bankName={benefisciary.account.bank}
										accNo={benefisciary.account.accNum}
										ifsc={benefisciary.account.ifsc}
										active={benefisciary.active}
										status={benefisciary.active}
										id={benefisciary.id} />
								))

							:
							<div>
								No beneficiary found.
							</div>
					}



				</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, benefisciaryList, agentInfo, token,clientRole,
			 selectSender, selecetdBenefisciaries } }
) => ({
	errorMessage, loginErrorMessage, phone, benefisciaryList, agentInfo, token, clientRole,selectSender, selecetdBenefisciaries
});

export default connect(mapStateToProps, null)(AddedBeneficiary);
